<div class="wrapper">
    <ul>
        <li *ngFor="let path of pathParts; index as i" (click)="goTo(path.linkValue)">{{path.prettyName}}
            <mat-icon *ngIf="i !== pathParts.length - 1">keyboard_arrow_right</mat-icon>
        </li>
    </ul>
</div>
